import styled from '@emotion/styled';
import { Colors } from '../../../styles/variables/colors';
import { Breakpoints } from '../../../styles/variables/breakpoints';

const { white } = Colors;
const { sm, xxl } = Breakpoints;

export const Content = styled.div`
    padding-top: 36px;
    width: 93%;
    margin: auto;
`;

export const DisplayContent = styled.div`
    @media screen and (min-width: ${sm}) {
        min-width: 685px;
        width: 100%;
    }
    @media screen and (min-width: ${xxl}) {
        display: flex;
        gap: 40px;
        align-items: flex-start;
    }
`;

export const InnerContent = styled.div`
    width: 100%;
`;

export const Main = styled.main`
    display: flex;
`;

export const Title = styled.h1`
    font-style: normal;
    line-height: 34px;
    text-transform: capitalize;
    margin-bottom: 2.5rem;
`;

export const SelfAssessmentSection = styled.div`
    max-width: 1256px;
    min-width: 335px;
    margin: auto;
    padding-bottom: 36px;
    margin-top: 150px;
    background-color: ${white};
    @media screen and (min-width: ${sm}) {
        min-width: 727px;
        max-width: 1256px;
        width: 95%;
    }
    @media screen and (min-width: ${xxl}) {
        width: 1256px;
    }
`;
